const targetStockCSSInject = document.documentElement;

const cssCache = new Map<string, string>();

export const getCSS = (variable: string) => {
  if (cssCache.has(variable)) {
    return cssCache.get(variable)!;
  }

  try {
    const value =
      getComputedStyle(targetStockCSSInject)?.getPropertyValue(variable) ??
      'green';
    cssCache.set(variable, value);
    return value;
  } catch (error) {
    cssCache.set(variable, 'green');
    return 'green';
  }
};

export const setCSS = (variable: string, value: string) =>
  targetStockCSSInject.style.setProperty(variable, value);

const remCache = new Map<number, string>();

export const remCSS = (value: number) => {
  if (remCache.has(value)) {
    return remCache.get(value)!;
  }

  const result = `${value / 16}rem`;
  remCache.set(value, result);
  return result;
};

export const remNumber = (value: number, threshold: number = 0) => {
  return value * (1 + threshold / 100);
};
